<template>
    <GmapMap
        :center="{lat:-33, lng:-71}"
        :zoom="5"
        :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
        }"
        >
        <GmapInfoWindow
            :position="infoWindow.position"
            :opened="infoWindow.open"
            :options="infoWindow.template"
            :content="null"
            @closeclick="infoWindow.open=false"
            />
        <GmapMarker
            :icon="{url: require('@/assets/icons/pin.svg')}"
            :position="{lat:m.latitude, lng: m.longitude}"
            :clickable="true"
            :label="{'text':' '}"
            v-for="(m, index) in markers"
            :key="index"
            @click="openInfoWindowTemplate(m)"
            />
    </GmapMap>
</template>

<script>
import MapCard from '@/components/cards/MapCard'

export default {
    name: 'MapCard',
    props: ['markers'],
    data: function(){
        return {
            infoWindow: {
                position: {lat: 0, lng: 0},
                open: false,
                template: {}
            }
        }
    },
    methods: {
        infoOptions: function(marker) {
            return {
                pixelOffset: {
                    width: 0,
                    height: -35
                },
                content:
                    '<div>'+
                    '<div>'+
                    '<h1 id="name-map-info" class="firstHeading">'+marker.name+'</h1>'+
                    '</div>'+
                    '<div onclick="openModal('+marker.id+')">'+
                    '<p id="location-map-info">Detalle</p>'+
                    '</div>'+
                    '</div>'
            }
        },
        openInfoWindowTemplate (item) {
            this.infoWindow.template = this.infoOptions(item)
            this.infoWindow.position = {lat:item.latitude, lng: item.longitude}
            this.infoWindow.open = true
        },
        openModal: function(id){
            this.$emit('openModal', id)
        }
    }
}

window.openModal = function (id){
    vm.$children[0].$children[0].$children[0].$children[1].$children[1].openModal(id)
}
</script>

<style lang="sass">
.gm-style .gm-style-iw-c
    user-select: none
    width: 202px
    left: 0
    padding: 0
    padding-left: 8px
#name-map-info
    font-family: Montserrat
    font-size: 14px
    font-weight: 600
    color: $dark
    margin: 8px 0 4px
#location-map-info
    font-family: Muli
    font-size: 12px
    font-weight: 300
    color: $dark
    cursor: pointer
#location-map-info:hover
    color: $secondary-hover
.vue-map
    border-radius: 4px
</style>